import React from 'react';
import styled from 'styled-components';
import {
  Container,
  Row,
  Col,
} from 'reactstrap';

const Wrapper = styled.footer`
  position: absolute;
  bottom: 0;
  width: 100%;
  padding: 22px 0 20px;
  text-shadow: 1px 1px 2px rgba(0, 0, 0, 0.3);
`;

const Span = styled.span`
  font-size: 0.8em;
  color: white;
`;

const LeftSpan = styled(Span)`
  float: left;
`;

const RightSpan = styled(Span)`
  float: right;
`;

const Footer = () => (
  <Wrapper>
    <Container>
      <Row>
        <Col>
          <LeftSpan>&copy; 2018 Two's Complement LLC</LeftSpan>
          <RightSpan>❤ &nbsp;Boulder, Colorado, USA</RightSpan>
        </Col>
      </Row>
    </Container>
  </Wrapper>
);

export default Footer;



// WEBPACK FOOTER //
// ./src/components/ui/Footer.js